import CheckoutListingPage from "repoV2/features/CheckoutPages/modules/CheckoutListingPage/CheckoutListingPage";

export default CheckoutListingPage;
